import type { FC, ReactChild } from 'react';
import React from 'react';

type CollapsibleListContextProps = {
  expandedItemId?: string;
  setExpandedItemId: (id: string) => void;
  children: ReactChild;
};

type ContextType = {
  expandedItemId?: string;
  setExpandedItemId: (id: string) => void;
};

export const CollapsibleListContext = React.createContext<ContextType>(
  null as unknown as ContextType
);

export const CollapsibleListContextProvider: FC<CollapsibleListContextProps> = ({
  expandedItemId,
  setExpandedItemId,
  children,
}) => {
  return (
    <CollapsibleListContext.Provider value={{ expandedItemId, setExpandedItemId }}>
      {children}
    </CollapsibleListContext.Provider>
  );
};
